import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { AppDataProvider } from './contexts/AppDataContext';
import { CompanySettingsProvider } from './contexts/CompanySettingsContext';
import { DocumentsProvider } from './contexts/DocumentsContext';
import { DocumentTypesProvider } from './contexts/DocumentTypesContext';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import { LocalStorageService } from './utils/localStorageService';

import Layout from './components/layout/Layout';
import ProtectedRoute from './components/common/ProtectedRoute';
import LoginPage from './pages/auth/LoginPage';
import Dashboard from './pages/Dashboard';

import ProductsPage from './pages/products/ProductsPage';
import StockPage from './pages/stock/StockPage';
import SuppliersPage from './pages/suppliers/SuppliersPage';
import CustomersPage from './pages/customers/CustomersPage';
import OrdersPage from './pages/orders/OrdersPage';
import SalesPage from './pages/sales/SalesPage';
import PurchasesPage from './pages/purchases/PurchasesPage';
import WarehousesPage from './pages/warehouses/WarehousesPage';
import WarehouseInventoryPage from './pages/warehouses/WarehouseInventoryPage';
import ReturnsPage from './pages/returns/ReturnsPage';
import DocumentsPage from './pages/documents/DocumentsPage';

import ReportsPage from './pages/reports/ReportsPage';
import AdvancedAnalyticsPage from './pages/advanced-analytics/AdvancedAnalyticsPage';
import SettingsPage from './pages/settings/SettingsPage';
import EmployeesPage from './pages/employees/EmployeesPage';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// Initialiser les données par défaut dans localStorage
LocalStorageService.initializeDefaultData();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <ThemeProvider>
          <AuthProvider>
            <AppDataProvider>
              <CompanySettingsProvider>
                <DocumentsProvider>
                  <DocumentTypesProvider>
                    <Router>
                <Routes>
                  <Route path="/login" element={<LoginPage />} />
                  
                  {/* Protected routes */}
                  <Route element={<ProtectedRoute />}>
                    <Route path="/" element={<Layout />}>
                      <Route index element={<Dashboard />} />
                      <Route path="dashboard" element={<Dashboard />} />
                      <Route path="products/*" element={<ProductsPage />} />
                      <Route path="stock/*" element={<StockPage />} />
                      <Route path="suppliers/*" element={<SuppliersPage />} />
                      <Route path="customers/*" element={<CustomersPage />} />
                      <Route path="orders/*" element={<OrdersPage />} />
                      <Route path="sales/*" element={<SalesPage />} />
                      <Route path="purchases/*" element={<PurchasesPage />} />
                      <Route path="warehouses" element={<WarehousesPage />} />
                      <Route path="warehouses/inventory/:warehouseId" element={<WarehouseInventoryPage />} />
                      <Route path="warehouses/*" element={<WarehousesPage />} />
                      <Route path="returns/*" element={<ReturnsPage />} />
                      <Route path="documents/*" element={<DocumentsPage />} />
            
                      <Route path="advanced-analytics/*" element={<AdvancedAnalyticsPage />} />
                      <Route path="reports/*" element={<ReportsPage />} />
                      <Route path="settings/*" element={<SettingsPage />} />
                      <Route path="employees/*" element={<EmployeesPage />} />
                    </Route>
                  </Route>
                </Routes>
                <Toaster
                  position="top-right"
                  toastOptions={{
                    className: 'bg-white/90 backdrop-blur-sm border border-white/20 shadow-xl',
                    style: {
                      background: 'rgba(255, 255, 255, 0.9)',
                      backdropFilter: 'blur(12px)',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                    },
                  }}
                />
                  </Router>
                  </DocumentTypesProvider>
                </DocumentsProvider>
              </CompanySettingsProvider>
            </AppDataProvider>
          </AuthProvider>
        </ThemeProvider>
      </LanguageProvider>
    </QueryClientProvider>
  );
}

export default App; 